export default __webpack_public_path__ + "static/media/logOutSprite.c0d654c7.svg";